export const LAST_SESSION_DATE = 'lastSession';

export const APP_ID = 'appId';
export const EVENT_TYPES = 'eventTypes';
export const BUSINESS_PARTNER = 'businessPartnerId';
export const AD_ID = 'advertisingId';
export const REG_ACTION_ID = 'regActionId';
export const UM_ID = 'umid';
export const PERIOD = 'period';
export const PARTNER_CLICK_ID = 'partnerClickId';
export const APPSFLYER_ID = 'appsflyerId';
export const PLAYER_ID = 'playerId';

export const POSTBACK_AND_CONVERSIONS_STATUSES = 'searchPostbacksConversions';

export const TEMPLATE_PLAYERS_INFORMATION = 'playersInformation';

export const REGULAR_EVENT = 'regularEvent';
export const RECURRENT_EVENT = 'recurrentEvent';

export const PROMO_CODES = 'promoCodesIds';

export const INVITER = 'isInviter';
export const INVITED = 'isInvited';
